import { Directive, effect, EffectRef, ElementRef, inject, input, InputSignal, OnDestroy } from "@angular/core";

@Directive({
    selector: "[cssInjectionScope]",
    standalone: false
})
export class CssInjectionScopeDirective implements OnDestroy {
    public static ScopeAttribute: string = "cssInjectionScope";
    public static StylesAttribute: string = "cssInjectionForScope";

    private el: ElementRef = inject(ElementRef);

    // Directive input signals.
    public cssInjectionScope: InputSignal<string> = input();

    // Directive effects.
    private cssInjectionScopeInputEffect: EffectRef = this.getCssInjectionScopeInputEffect();

    // Effect builders.
    private getCssInjectionScopeInputEffect(): EffectRef {
        return effect(() => {
            const cssInjectionScope: string = this.cssInjectionScope();

            this.el.nativeElement.setAttribute(CssInjectionScopeDirective.ScopeAttribute, cssInjectionScope);
        });
    }

    // Directive lifecycles.
    public ngOnDestroy(): void {
        this.cssInjectionScopeInputEffect.destroy();
    }
}